import { store } from "@/store/store";
import { AccountType } from "@/enums/account-type";

export const permissionCheck = permission => {
  const { company } = store.state.company;

  if (company && company.company_user && company.company_user.permissions) {
    return company.company_user.permissions[permission];
  }

  return false;
};

export const allFacilitiesAccessCheck = () => {
  const { company } = store.state.company;

  if (company && company.company_user) {
    return (
      company.company_user.all_facilities_access ||
      company.company_user.type === AccountType.OWNER ||
      company.company_user.type === AccountType.ADMIN
    );
  }

  return false;
};
